// extracted by mini-css-extract-plugin
export default {"modal-share":"ModalShare_modal-share__iDARM","modal-share-select":"ModalShare_modal-share-select__nSRu3","modal-share-textarea":"ModalShare_modal-share-textarea__SaSwi"};